import axios from 'axios';
import authHeader from './auth-header';
import { handleResponse } from './handle-response';
import AuthService from "./auth.service";

const API_URL = 'https://rh.industriabasica.net/api/v1/';
//const API_URL = 'https://www.mihorario.com.ar/api/v1/';
//const API_URL = 'https://localhost:8000/api/test/';

//console.log('puto');
//console.log(authHeader());
const user = JSON.parse(localStorage.getItem('user'));

class UserService {
  
  getPublicContent() {
   // const requestOptions = { method: 'POST', headers: authHeader() };
   // return fetch(`http://rh.casiba.net/api/v1/solicitudes1`, requestOptions) ;
   // return axios.post(API_URL + 'solicitudes1', { headers: authHeader() });
  }

  getUserBoard() {
    //return axios.post(`${API_URL}/solicitudes1`, { headers: authHeader() });
    //const data = new URLSearchParams("email="+user.email);
    //const data= JSON.stringify({
    //  email: user.email
    //});
    const data = new FormData();
    data.append('email', user.email);

    const requestOptions = { method: 'POST',body:data, headers: authHeader() };
    return fetch(API_URL + 'solicitudes1', requestOptions);

    
    //const user = JSON.parse(localStorage.getItem('user'));

    //return axios.post(API_URL + "solicitudes1", '',  {headers: {'Authorization': 'Bearer ' + user.accessToken}} );

    //return axios.post(API_URL + 'solicitudes1', { headers: authHeader() });
  }

  getModeratorBoard() {
    return axios.post(API_URL + 'mod', { headers: authHeader() });
  }

  getAdminBoard() {
    //return axios.post(API_URL + "solicitudes1", {headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'}} ); 
    return axios.post(API_URL + 'solicitudes1', { headers: authHeader() });
  }

  setEntrar(latitud, longitud) {
    const data = new FormData();
    data.append('email', user.email);
    data.append('latitud', latitud);
    data.append('longitud', longitud);
    data.append('accion', 'entrada');
    data.append('momento', 'remota');

    const requestOptions = { method: 'POST',body:data, headers: authHeader() };
    return fetch(API_URL + 'entrar1', requestOptions);
  }
  
  getStockNuban(props) {
    const data = new FormData();
    if(user){
      data.append('email', user.email);
      const requestOptions = { method: 'POST',body:data, headers: authHeader() };
      return (fetch(API_URL + 'stocknuban', requestOptions).then(handleResponse));
    }else{
      return null 
    }
  }

  getStockExpanmetal() {
    const data = new FormData();
    if(user){
      data.append('email', user.email);
      const requestOptions = { method: 'POST',body:data, headers: authHeader() };
      return (fetch(API_URL + 'stocknumet', requestOptions).then(handleResponse));
    }else{
      return null 
    }
  }

}

export default new UserService();
